import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Grid,
  Fab,
  Icon,
  TextField,
  FormHelperText,
  Dialog,
  DialogContent,
  DialogTitle,
  Switch
} from '@material-ui/core';
import {
  getSMBannersAPI,
  createSMBannerAPI,
  updateSMBannerAPI,
} from 'api';
import { uploadFileTypeUnsupported } from 'redux/actions/general';


const BannerSlideModal = ({slideData, setOpen}) => {
  const dispatch = useDispatch();
  const [dargClass, setDragClass] = useState('');
  const [bannerData, setBannerData] = useState(slideData);

  const handleDragStart = () => setDragClass('drag-shadow');

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragClass('drag-shadow');
  };

  useEffect(() => {
    getSMBannersAPI({dispatch});
  }, []);

  const handleSaveSlide = () => {
    const formData = new FormData();

    for (const key in bannerData) {
      const element = bannerData[key];
      formData.append(key, element);
    }

    if (bannerData._id) {
      updateSMBannerAPI({dispatch, formData, id: bannerData._id});
    } else {
      createSMBannerAPI({dispatch, formData});
    }

    setOpen(false);
  };

  const handleUploadSlideOnDrag = (event) => {
    event.preventDefault();

    const {files} = event.dataTransfer;
    const fileName = files[0].name;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');

    if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
      dispatch(uploadFileTypeUnsupported());
      setDragClass('');
      return setBannerData((d) => ({...d, image: ''}));
    }

    setDragClass('');
    return setBannerData((d) => ({...d, image: files[0]}));
  };

  const handleUpLoadSlide = (event) => {
    const {files} = event.target;
    const fileName = event.target.value;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');

    if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
      dispatch(uploadFileTypeUnsupported());
      return setBannerData((d) => ({...d, image: ''}));
    }

    return setBannerData((d) => ({...d, image: files[0]}));
  };

  return (
    <Dialog
      open={!!slideData}
      onClose={() => setOpen(false)}
      aria-labelledby="edit-slide"
      fullWidth
      maxWidth={'md'}
    >
      <DialogTitle
        id="edit-slide"
      >
        {bannerData._id ? 'Edite Slide' : 'Create Slide'}
      </DialogTitle>
      <DialogContent
        className="px-8 pb-8"
      >
        <Grid container>
          <Grid item xs={12}>
            {bannerData.image ?
              <img src={typeof bannerData.image === 'object' ? URL.createObjectURL(bannerData.image) : bannerData.image} alt="slide" className="max-w-full" />
              :
              <>
                <div
                  className={`h-300 w-full p-4 flex-column justify-center items-center dropzone ${dargClass}`}
                  onDragEnter={handleDragStart}
                  onDragOver={handleDragOver}
                  onDrop={handleUploadSlideOnDrag}
                >
                  <div>
                    <Icon className="pr-8 text-48" fontSize="large" color="primary">cloud_upload</Icon>
                  </div>

                  <span className="font-bold text-16 text-brand">
                    {'Drag and drop your file here'}
                    <span className="text-error">*</span>
                  </span>
                  <span className="text-13 text-muted">Files supported:  JPG, JPEG, PNG</span>
                  <p className="text-13 text-brand my-2">or</p>
                  <label htmlFor="upload-slide-image">
                    <Fab
                      component="span"
                      variant="extended"
                      className="border-radius-30 capitalize bg-white text-13 h-30px text-primary font-bold border-1-primary box-shadow-none"
                    >
                      Browse file
                    </Fab>
                  </label>
                  <input
                    className="hidden"
                    onChange={handleUpLoadSlide}
                    id="upload-slide-image"
                    type="file"
                    accept="image/png, image/jpeg"
                  />
                </div>
                {Boolean(bannerData.image) &&
                  <FormHelperText
                    error
                    className="pl-4"
                  >
                    Field is required
                  </FormHelperText>
                }
              </>
            }
            {bannerData.image &&
            <Grid item xs={12}>
              <label htmlFor="upload-image">
                <Fab
                  component="span"
                  variant="extended"
                  className="border-radius-30 capitalize bg-white text-13 h-30px text-primary font-bold border-1-primary box-shadow-none w-full"
                >
                  <Icon className="pr-8" color="primary">cloud_upload</Icon>
                  <span>Upload New Image</span>
                </Fab>
              </label>
              <input
                className="hidden"
                onChange={handleUpLoadSlide}
                id="upload-image"
                type="file"
                accept="image/png, image/jpeg"
              />
            </Grid>}
          </Grid>
        </Grid>
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>Enabled:</Grid>
          <Grid item xs={12} md={9}>
            <Switch
              onChange={({target}) => setBannerData((d) => ({...d, enabled: target.checked }))}
              checked={bannerData?.enabled}
              color="primary"
              name="enabled"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </Grid>
        </Grid>
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>Open in new tab:</Grid>
          <Grid item xs={12} md={9}>
            <Switch
              onChange={({target}) => setBannerData((d) => ({...d, openInNewTab: target.checked }))}
              checked={bannerData?.openInNewTab}
              color="primary"
              name="openInNewTab"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </Grid>
        </Grid>
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>On click url:</Grid>
          <Grid item xs={12} md={9}>
            <TextField
              className="w-full"
              label="Url"
              name="onClickUrl"
              value={bannerData.onClickUrl}
              onChange={(e) => {
                const {value} = e.target;
                setBannerData((d) => ({...d, onClickUrl: value }));
              }}
            />
          </Grid>
        </Grid>
        <Grid container className="p-4 flex items-center justify-around">
          <Button
            color="primary"
            variant="contained"
            className="capitalize"
            onClick={handleSaveSlide}
          >
            Save Slide
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BannerSlideModal;
